import { uuid as e } from "../ids.mjs";
//#region src/core/lifecycle/webLifecycle.ts
var t = "maat_tab_id", n = { bind(e) {
	let t = () => {
		document.visibilityState === "hidden" && e(!1);
	}, n = () => e(!0);
	return document.addEventListener("visibilitychange", t), window.addEventListener("beforeunload", n), () => {
		document.removeEventListener("visibilitychange", t), window.removeEventListener("beforeunload", n);
	};
} };
function r() {
	let n = sessionStorage.getItem(t);
	if (n) return n;
	let r = e();
	return sessionStorage.setItem(t, r), r;
}
//#endregion
export { r as resolveWebTabId, n as webLifecycle };
